export const DEFAULT_PRIVATE_FEATURE_FLAGS = {
  bio_salutation_allowed: false,
  internalLeadFormToggle: false,
  videoEmbed_url: false,
  videoEmbed_uploadFile: false,
  referralProgram: false,
  changeRequests: false,
  iam: false,
  profileSync: false,
  ssoSelfServiceEdit: false,
  ssoSelfServiceCreate: false,
  ssoSelfServiceGenerateEditTicket: false,
  ssoSelfServiceGenerateCreateTicket: false,
  ssoTestSameBrowser: false,
  'multiple-idps': false,
  profileShare_uidParam: false,
  emailTemplates: false,
  userDefinedTranslations: false,
  crmIntegration: false,
  crm_importCustomFields: false,
  crm_getDynamicsPicklistAttributesMetadata: false,
  emailSignature: false,
  invitationEmailV2: false,
  leadEnrichment: false,
  linkedInScraping: false,
  filterEngine_contacts: false,
  domainVerification: false,
  themeConfigGlobalReset: false,
  udtExcel: false,
  onboardingEmail: false,
  walletConfig_background: false,
  phoneInputRaw: false,
  businessCardScanner: false,
  businessCardScanner_useFullScreenVideo: false,
  businessCardScanner_badge_openai: false,
  businessCardScanner_badge_v3: false,
  businessCardScanner_badge_v2: false,
  businessCardScanner_bcs_openai: false,
  businessCardScanner_bcs_v3: false,
  businessCardScanner_bcs_v2: false,
  businessCardScanner_openai: false,
  businessCardScanner_v3: false,
  businessCardScanner_v2: false,
  bcs_wazzl: false,

  voiceNotes: false,
  voiceNotes_aiActions_openai: false,
  voiceNotes_transcription_reTranscribe: false,
  voiceNotes_transcription_aws: false,
  voiceNotes_transcription_assemblyai: false,
  voiceNotes_transcription_assemblyai_langDetection: false,
  voiceNotes_transcription_azureopenai: false,

  academyV2: false,
};

export const DEFAULT_PUBLIC_FEATURE_FLAGS = {
  sales_hidePrices: false,
};

export type PrivateFeatureFlags = typeof DEFAULT_PRIVATE_FEATURE_FLAGS;
export type PublicFeatureFlags = typeof DEFAULT_PUBLIC_FEATURE_FLAGS;
